export default "__VITE_ASSET__1f1645d8__"